import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { useSearchParams } from 'react-router-dom';
import { coinApi } from '../../../api/coin';
import Investments from '../../../components/ui/Investments';
import { selectFilterOption } from '../../../store/reducers/coin';
import styles from './InvestorPortfolio.module.scss';

const InvestPortfolio = ({ address, holders }) => {
  const { network } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const filterOption = useSelector(selectFilterOption);
  const initialSearchParams = {
    ...Object.fromEntries([...searchParams]),
  };

  const [queryParams, setQueryParams] = useState({
    page: Number(initialSearchParams.page) || 1,
    desc: initialSearchParams.order !== 'false',
    type: initialSearchParams.sort,
    order: initialSearchParams.orderBy || 'value',
    limit: initialSearchParams.perPage || 25,
  });

  const [checkedToken, setCheckedToken] = useState(queryParams.type !== 'nft');
  const [checkedNft, setCheckedNft] = useState(queryParams.type !== 'token');

  const { page, desc, type, order, limit } = queryParams;

  const {
    data: investments,
    isLoading: isInvestmentsLoading,
    isFetching: isInvestmentsFetching,
  } = coinApi.useGetNftInvestmentsQuery({
    address,
    des: desc ? '1' : '0',
    asset_type: type || '',
    chain: network,
    limit: +limit,
    order,
    page,
    audience: filterOption,
  });

  useEffect(() => {
    let newType = '';

    if (checkedNft && checkedToken) {
      newType = '';
    } else if (checkedNft && !checkedToken) {
      newType = 'nft';
    } else if (!checkedNft && checkedToken) {
      newType = 'token';
    }

    setQueryParams((prevState) => ({
      ...prevState,
      type: newType,
    }));

    const newSearchParams = new URLSearchParams(searchParams.toString());
    newSearchParams.set('sort', newType);
    newSearchParams.set('page', page.toString());
    newSearchParams.set('order', desc ? 'true' : 'false');
    setSearchParams(newSearchParams);
  }, [checkedNft, checkedToken, page, desc]);

  return (
    <div className={styles.wrapper}>
      <Investments
        investments={investments}
        isLoading={isInvestmentsLoading || isInvestmentsFetching}
        limit={limit}
        setLimit={(newLimit) =>
          setQueryParams({ ...queryParams, limit: newLimit })
        }
        holders={holders}
        page={page}
        desc={desc}
        setPage={(newPage) => setQueryParams({ ...queryParams, page: newPage })}
        setDesc={(newDesc) => setQueryParams({ ...queryParams, desc: newDesc })}
        setCheckedToken={setCheckedToken}
        setCheckedNft={setCheckedNft}
        checkedToken={checkedToken}
        checkedNft={checkedNft}
        order={order}
        setOrder={(newOrder) =>
          setQueryParams({ ...queryParams, order: newOrder })
        }
      />
    </div>
  );
};

export default InvestPortfolio;
